import React from 'react'
import { useLoaderData } from 'react-router';

const OneSingleProject = () => {
    const data = useLoaderData()
    const { name, dscOne, dscTwo, dscThree, imageOne, imageTwo, imageThree } = data;


    return (
        <div>
            <div className="container max-w-4xl px-10 py-6 mx-auto rounded-lg shadow-sm dark:bg-gray-900">
                <div className="mt-3">
                    <a rel="noopener noreferrer" href="#" className="text-2xl font-bold hover:underline">{name}</a>
                    <p className="mt-2 mb-2 text-2xl">{dscOne}</p>
                </div>
                <figure>
                    <img src={imageOne} alt="" className="h-64" />
                </figure>

                <figure>
                    <img src={imageTwo} alt="" className="h-64" />
                </figure>
                <p className="mt-2 text-2xl mb-2">{dscTwo}</p>
                <figure>
                    <img src={imageThree} alt="" className="h-64" />
                </figure>
                <p className="mt-2 text-2xl">{dscThree}</p>
            </div>
        </div>
    )
}

export default OneSingleProject
